<template lang="pug">
.container.col-centered
  .row
    //- h2.main_title Firmware change log
    h2.main_title Private MIB Change Log
    .col-md-12.function_bar(style="display:flex; justify-content: space-between;")
      .form-group(v-bind:class="{'col-md-4': $route.name === 'switch', 'col-md-2': $route.name === 'smart-controller'}")
        label.control_label
          | Custom:
        v-select(v-bind:value.sync='logFilter.custom.value' v-bind:options='logFilter.custom.opts')
    spinner(v-ref:spinner size="md" show="true" v-bind:text="spinnerTxt")
    div(ng-if="pageLoaded")
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='statusFilteredTotalLog'
      )
      .col-md-12.main_table(v-if="statusFilteredTotalLog.length > 0")
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, mib) in statusFilteredTotalLog  | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media
                .media-body
                  .media-top
                    span.version.text-uppercase {{ getCustomForUI(mib.custom) }} - {{ mib.version }}
                    span.time
                      span.glyphicon.glyphicon-time
                      span(v-if="sortMethod.name !== 'updatedAt'") Released at {{ mib.createdAt | fromNow }}
                      span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ mib.updatedAt | fromNow }}
                    .action_buttons.pull-right
                      .btn-group
                        button.btn.btn-default(@click="handleShowModal('update', mib['.key'], $index)" v-if="['admin', 'vendor'].includes(user.role)")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-default(@click="handleShowDeleteConfirm(mib['.key'], mib.category)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        button.btn.btn-default(@click="handleShowDownloadModal(mib)" v-bind:disabled="getModelOptions(mib).length === 0")
                          span.glyphicon.glyphicon-cloud-download
                          span  Download
                  .media-middle
                    line-table(title='Features:' v-bind:content='mib.feature' v-if='mib.feature.length !== 0')
                    line-table(title='BugFixes:' v-bind:content='mib.bugFixed' v-if='mib.bugFixed.length !== 0')
                .media-right.badge_group
                  .customized__badge(v-bind:class="mib.status === 'release' ? 'release' : 'develop'")
                    span {{mib.status === 'release' ? 'release' : 'develop' }}
      .col-md-12(v-if="statusFilteredTotalLog.length <= 0")
        h3.text-center.text-muted No Data
  modal(
    v-bind:title.sync='modalTitle'
    v-bind:ok-text.sync='okText'
    backdrop='false'
    v-bind:callback='modalCb'
    v-bind:show.sync='showModal')
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix(v-if='isUpdate')
          .col-md-3.form_label.clearfix
            label.control_label
              | Last update:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='newPMIB.updatedAt' readonly)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Date:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='newPMIB.createdAt' readonly v-if="user.role !== 'admin'")
            datepicker(v-bind:value.sync="newPMIB.createdAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Version:
          .col-md-9.no_pad.clearfix
            input.form-control(readonly v-bind:value="newPMIB.version")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Status:
          .col-md-9.no_pad.clearfix
            v-select(
              v-if="user.role === 'admin'"
              v-bind:value.sync="newPMIB.status"
              v-bind:options="[{label: 'Release', val: 'release'}, {label: 'Develop', val: 'develop'}]"
              options-value="val"
              close-on-select
            )
            input.form-control(v-else readonly v-bind:value="newPMIB.status[0].toUpperCase() + newPMIB.status.substr(1)")
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Feature:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='newPMIB.feature' placeholder='' v-bind:disabled="user.role === 'client'")
  modal(
    title='Select Private MIB'
    backdrop='false'
    v-bind:show.sync='showDownloadModal'
  )
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Model:
          .col-md-9.no_pad.clearfix
            v-select(
              v-if="getModelOptions(downloadTarget.candidates).length > 0"
              v-bind:value.sync="downloadTarget.filter.model"
              v-bind:options="getModelOptions(downloadTarget.candidates)"
              options-value="val"
              search justified required close-on-select
            )
            input.form-control(readonly value="No model matched." v-else)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Layer:
          .col-md-9.no_pad.clearfix
            v-select(options-value="val" v-bind:value.sync="downloadTarget.filter.layerMode" v-bind:options="layerModeOpts")
    .modal-footer.upload_modal(slot='modal-footer')
      button.btn.btn-default(@click="cancelDownloadModal") Cancel
      button.btn.btn-primary(@click="downalodMib" v-bind:disabled="downloadTarget.filter.layerMode == null || downloadTarget.filter.model == null || mibUrlLoadingState === 1") {{ mibUrlLoadingState === 0 ? 'Download' : mibUrlLoadingState === 1 ? 'Loading...' : mibUrlLoadingState === 2 ? 'Downloading' : 'Error'}}
  modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm')
    .l-body(slot='modal-body')
      h4.text-center Are you sure to delete?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showDeleteConfirm = false')
        | No
      button.btn.btn-danger(@click='applyDelete')
        | Yes
</template>
<script>
import moment from 'moment'
import { datepicker, dropdown, modal, select, spinner } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable'
import { store, getFireBase, getModelForUI, getCustomForUI, naturalSorting, getIconSrc, getDb, filterOptions, snmpOidDocOpts } from '../../index.js'
import _ from 'lodash'

const fb = getFireBase()
export default {
  components: {
    datepicker,
    dropdown,
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable,
    spinner
  },
  vuex: {
    getters: {
      user: state => state.user,
      firmwareInfo: state => state.firmware,
      mibFliterStore: state => state.mibFliterStore,
      isMibFilterStoreEmpty: state => state.isMibFilterStoreEmpty
    }
  },
  data () {
    return {
      pageLoaded: false,
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'version',
        asc: false
      },
      sortMethodOpts: [
        {
          label: 'Sort by Release Date',
          value: 'createdAt'
        },
        {
          label: 'Sort by Update Time',
          value: 'updatedAt'
        },
        {
          label: 'Sort by Version',
          value: 'version'
        }
      ],
      newPMIB: {
        model: null,
        category: '',
        custom: '',
        url: '',
        feature: '',
        bugFixed: '',
        createdAt: '',
        updatedAt: '',
        version: '',
        status: ' '
      },
      option: {
        model: {
          opts: []
        },
        status: {
          opts: filterOptions.status.firmware
        }
      },
      showModal: false,
      showDownloadModal: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      editingCategory: '',
      showDeleteConfirm: false,
      logFilter: {
        family: {
          opts: [
            {label: 'Any', value: 'any'}
          ],
          value: 'any'
        },
        custom: {
          opts: filterOptions.custom,
          value: 'any'
        },
        date: {
          opts: [
            {label: 'Any', value: 'any'},
            {label: '1 month', value: 'month'}
          ],
          value: 'any'
        },
        category: {
          opts: filterOptions.category, // dynamic generated by $route.name
          value: 'any'
        },
        status: {
          opts: filterOptions.category, // dynamic generated by $route.name
          value: 'any'
        }
      },
      isUpdate: false,
      snmpOidDocOpts,
      searchModelTxt: '',
      downloadTarget: {
        candidates: {},
        filter: {
          layerMode: null,
          model: null
        }
      },
      mibUrlLoadingState: 0,
      spinnerTxt: 'Loading...',
      pmib: [],
      product: []
    }
  },
  ready () {
    this.$refs.spinner.show()
    // gen logFilter
    let optAny = {label: 'Any', value: 'any'}
    if (['pandacom@lantechcom.tw', 'db@lantechcom.tw'].includes(this.user.email)) {
      this.logFilter.category.opts = [{label: 'RouterX', value: 'routerx'}]
    } else {
      this.logFilter.category.opts = _.cloneDeep(filterOptions.category)
    }
    this.logFilter.category.opts.unshift(optAny)
    this.logFilter.custom.opts = _.cloneDeep(filterOptions.custom)
    this.logFilter.custom.opts.unshift(optAny)
    this.logFilter.status.opts = _.cloneDeep(filterOptions.status.product)
    this.logFilter.status.opts.unshift(optAny)

    /*
      If page is redirected from product page,
      then need to check the mibFliterStore in vuex and update the filter.
    */
    if (!this.isMibFilterStoreEmpty) {
      this.logFilter.category.value = this.mibFliterStore.category.toLowerCase()
      this.logFilter.family.value = this.mibFliterStore.family
      this.logFilter.custom.value = this.mibFliterStore.custom.toLowerCase()
    }

    if (this.user.custom != null) {
      this.getData(this.user.custom)
    }
  },
  computed: {
    layerModeOpts () {
      const selectedModel = this.downloadTarget.filter.model
      if (selectedModel == null) {
        return [
          { label: 2, val: 2 },
          { label: 3, val: 3 }
        ]
      } else {
        const {l2, l3} = _.find(this.downloadTarget.candidates.models, {model: selectedModel})
        const result = []
        if (l2) result.push({ label: 2, val: 2 })
        if (l3) result.push({ label: 3, val: 3 })
        return result
      }
    },
    categorizedFamily () {
      // filterOptions.category
      const cf = {}
      for (let i in this.totalLog) {
        const cat = this.totalLog[i].category
        if (cf[cat] == null) cf[cat] = []
        cf[cat].push(this.totalLog[i].family)
        cf[cat] = _.uniq(cf[cat])
      }
      // console.log(cf)
      return cf
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    searchModelObj () {
      if (/^[a-zA-Z0-9-]+$/.test(this.searchModelTxt)) {
        return {
          isValid: true,
          value: this.searchModelTxt
        }
      } else if (this.searchModelTxt === '') {
        return {
          isValid: true,
          value: ''
        }
      } else {
        return {
          isValid: false,
          value: ''
        }
      }
    },
    totalLog () {
      let pmib = this.pmib
      // replace mib status to product status
      let prod = null

      switch (this.user.role) {
        case 'admin':
          break
        default: // client, vendor
          this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'carrier_switch')
          this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'viewer')
          this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'intrising')
          this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'microsens_npd7')
          this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'sercomm_dragon')
          this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value === 'any' || /* obj.value.toLowerCase() === 'lantech' || */ obj.value.toLowerCase() === this.user.custom.toLowerCase() || (this.user.email === 'eu@lantechcom.tw' && obj.value === 'lantech_pandacom'))
          break
      }

      pmib = pmib
        .map(x => {
          x.bugFixed = x.bugFixed == null ? '' : x.bugFixed
          x.models = x.models
          .map(y => {
            prod = this.product.filter(z => y.model === z['.key'])[0]
            if (prod != null) {
              y.category = prod.category
              y.custom = prod.custom
            }
            return y
          })
          return x
        }).filter(p => {
          return this.logFilter.custom.value !== 'any'
          ? p.custom === this.logFilter.custom.value
          // filter data in user-permission clustered custom-option
          : typeof (_.find(this.logFilter.custom.opts, {value: p.custom})) !== 'undefined'
        })

      const { name, asc: isAsc } = this.sortMethod
      if (name === 'version') {
        pmib = naturalSorting(pmib, 'version', isAsc ? 'asc' : 'desc')
      } else {
        pmib = _.orderBy(pmib, [name], [isAsc ? 'asc' : 'desc'])
      }
      return pmib
    },
    statusFilteredTotalLog () {
      return this.totalLog
    }
  },
  methods: {
    getLabel (type, val, isProd) {
      let target
      if (type === 'status') target = filterOptions[type][isProd ? 'product' : 'firmware']
      else target = filterOptions[type]
      return _.find(target, {value: val}) == null ? 'None' : _.find(target, {value: val}).label
    },
    checkStringEqual (src, target) {
      if (typeof src === 'string' && typeof target === 'string') {
        return src.toUpperCase() === target.toUpperCase()
      } else {
        return false
      }
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type,
        title,
        content
      })
    },
    handleDownload (url, e) {
      window.open(url)
    },
    getModelForUI,
    getCustomForUI,
    getIconSrc,
    handleShowModal (which, key, index) {
      // console.log('key', key)
      // console.log('index', index + this.pageStart)

      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add Private MIB'
        this.isUpdate = false
        this.okText = 'Add'
        let category, /* custom, */ model

        this.option.model.opts = []
        for (let p of this.product) {
          if (this.pmib[p.board] == null) {
            this.option.model.opts.push({label: p.board, value: p.board})
            if (this.option.model.opts.length <= 1) {
              model = this.option.model.opts[0].value
            }
            if (p['.key'] === model) {
              category = p.category
              // custom = p.custom
            }
          }
        }
        this.option.model.opts = _.uniqBy(this.option.model.opts, 'value')

        this.newPMIB = {
          model,
          category,
          // custom,
          url: '',
          feature: '',
          bugFixed: '',
          createdAt: moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
        }
        this.modalCb = this.applyUpload
      } else if (which === 'update') {
        this.modalTitle = 'Edit Private MIB'
        this.isUpdate = true
        this.okText = 'Update'
        this.modalCb = this.applyUpdate

        let { updatedAt = '', createdAt = '', bugFixed = '', feature = '', status, version } = this.statusFilteredTotalLog[index + this.pageStart]
        this.newPMIB.updatedAt = moment(updatedAt).format('YYYY/MM/DD HH:mm:ss')
        this.newPMIB.createdAt = moment(createdAt).format('YYYY/MM/DD HH:mm:ss')
        this.newPMIB.bugFixed = bugFixed
        this.newPMIB.feature = feature
        this.newPMIB.status = status
        this.newPMIB.version = version
        this.newPMIB.key = this.statusFilteredTotalLog[index + this.pageStart]['.key']
        this.showModal = true
      }
    },
    handleShowDownloadModal (target) {
      this.showDownloadModal = true
      this.downloadTarget.candidates = target
      this.downloadTarget.filter.model = this.getModelOptions(target)[0].val
    },
    getModelOptions (target) {
      const models = target.models || []
      const result = models.filter(({ model }) => {
        if (this.user.role === 'admin') return true
        else {
          const list = this.product.filter(z => model === z['.key'])
          return list.length && list[0].status === 'release'
        }
      }).map(({ model }) => ({
        label: model,
        val: model
      }))
      return naturalSorting(result, 'label', 'asc')
    },
    async downalodMib () {
      const {
        candidates: { version, custom },
        filter: { layerMode, model }
      } = this.downloadTarget
      const key = `${custom}_${version.replace(/\./g, '!')}_${model}_l${layerMode}`
      this.mibUrlLoadingState = 1
      const url = await fb.database().ref('mib/download').child(key).once('value').then((sn) => sn.val())
      this.mibUrlLoadingState = 2
      window.open(url)
      this.showDownloadModal = false
      this.mibUrlLoadingState = 0
    },
    cancelDownloadModal () {
      this.showDownloadModal = false
      this.downloadTarget = {
        candidates: {},
        filter: {
          layerMode: 2,
          model: null
        }
      }
    },
    handleShowDeleteConfirm (key, category) {
      this.editingKey = key
      this.editingCategory = category
      this.showDeleteConfirm = true
    },
    applyUpload () {
      let key = 'pmib'
      const {
        model,
        category,
        // custom,
        status,
        url,
        feature,
        bugFixed,
        createdAt
      } = this.newPMIB
      let toPush = {
        category,
        // custom,
        status,
        url,
        feature,
        bugFixed,
        createdAt: (new Date(createdAt)).getTime(),
        updatedAt: (new Date(createdAt)).getTime()
      }
      this.$firebaseRefs[key].child(model).set(toPush)
      this.showModal = false
    },
    applyUpdate () {
      const {
        key,
        status,
        feature
      } = this.newPMIB

      let update = {
        status,
        feature,
        updatedAt: fb.database.ServerValue.TIMESTAMP
      }
      getDb().ref('mib/entry').child(key).update(update)
      this.showModal = false
    },
    async applyDelete () {
      this.showDeleteConfirm = false
      const key = this.editingKey
      const models = this.pmib[key].models
      const version = this.pmib[key].version
      const linksToDelete = []
      for (let { model, l2, l3 } of models) {
        if (l2) linksToDelete.push(`${version.split(/\./g, '')}_${model}_l2`)
        if (l3) linksToDelete.push(`${version.split(/\./g, '')}_${model}_l3`)
      }
      for (let did of linksToDelete) {
        await fb.database().ref('newPrivateMib').child('downloadLinks').child(did).remove()
      }
      this.$firebaseRefs.pmib.child(key).remove()
      this.spinnerTxt = 'Deleteing...'
    },
    createTestData () { /** for creating Private MIB test data */
      const defaults = {
        status: ['develop', 'release'],
        models: ['IGS-3204MGSF3', 'IGS-3204MGSSS2', 'IGS-3248WJEH1']
      }
      const data = {
        bugFixed: 'Fixed some bugs',
        category: filterOptions.category[_.random(0, 3)].value,
        createdAt: 1500000000000 + (_.random(1, 9999) * 1000000),
        custom: filterOptions.custom[_.random(0, 7)].value,
        feature: 'add ' + _.random(1, 2, 1).toString().slice(0, 3) + ' upgrade',
        firmwareVersion: 'v' + _.random(2, 5, 1).toString().slice(0, 3) + 'r' + _.random(50, 80),
        model: defaults.models[_.random(0, 2)],
        status: defaults.status[_.random(0, 1)],
        updatedAt: 1500000000000 + (_.random(1, 99999) * 1000000),
        url: 'https://drive.google.com/uc?export=download&id=0B7_m7TkQhzE1bmZaRWNXOUc4UWM',
        version: 'v' + _.random(1, 10, 1).toString().slice(0, 3)
      }
      this.$firebaseRefs['pmib'].push(data)
    },
    getData (custom) {
      const isEu = this.user.email === 'eu@lantechcom.tw'  // HACK: the multi-custom access workarround for this account
      const query = ['admin', 'vendor'].includes(this.user.role) || isEu
          ? {
            mibEntry: getDb().ref('mib/entry'),
            product: getDb().ref('product')
          }
          : {
            mibEntry: getDb().ref('mib/entry').orderByChild('custom').startAt(custom).endAt(custom),
            product: getDb().ref('product').orderByChild(`custom/${custom}`).equalTo(custom)
          }
      query.mibEntry.on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.pageLoaded = true
          this.pmib = _.transform(sn.val(), (result, value, key) => {
            if (this.user.role !== 'admin' && !this.user.email.endsWith('@intrising.com.tw') && value.status !== 'release') return
            result.push({
              '.key': key,
              ...value
            })
          }, []).filter(x => isEu ? ['lantech_lantech', 'lantech_pandacom'].includes(x.custom) : true)
        },
        () => {
          query.mibEntry.off()
        }
      )

      query.product.on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.pageLoaded = true
          this.product = _.transform(sn.val(), (result, value, key) => {
            result.push({
              '.key': key,
              ...value
            })
          }, []).filter(x => {
            if (isEu) {
              if (x.custom.lantech_lantech === 'lantech_lantech') return true
              else if (x.custom.lantech_pandacom === 'lantech_pandacom') return true
              else return false
            } else {
              return true
            }
          })
        },
        () => {
          query.product.off()
        }
      )
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
      }
    },
    'logFilter.category.value': function (nv, ov) {
      // console.log(nv)
      if (nv !== ov) {
        if (this.isMibFilterStoreEmpty) {
          this.logFilter.family.value = 'any'
        } else {
          this.logFilter.family.value = this.mibFliterStore.family
        }
      }
    },
    'logFilter.family.value': function (nv, ov) {
      // console.log('family', nv)
      if (nv !== ov) {
        if (!this.isMibFilterStoreEmpty) {
          const { category, custom, family } = this.mibFliterStore
          this.logFilter.category.value = category
          this.logFilter.custom.value = custom
          this.logFilter.family.value = family
          store.dispatch('deleteMibFilterInfo')
        }
      }
    },
    'user.custom' (curr, prev) {
      if (curr != null) {
        this.getData(curr)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';

.main_table{
  padding-bottom: 70px;
}

.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
  .form-group{
    float: left;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}

.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{

  }
  .version{
    display: inline-block;
    // width: 130px;
    padding:3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right:5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right:5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor:pointer;
    span{
      font-size: 14px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.warning{
  padding: 3px 5px;
  color: #fff;
  background-color: #f00;
}
.single_log{
  position: relative;
  overflow: hidden;
}
.badge_group{
  padding-right: 40px;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-56px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right:-50px;
  }
}
.error{
  border:2px solid #e33;
}
.err_msg{
  padding-right: 7px;
  padding-left: 7px;
  & span{
    display: inline-block;
    white-space: nowrap;
    line-height: 30px;
    font-size: 12px;
    width:100%;
    height:30px;
    background-color: #e33;
    color: #fff;
    padding: 0px 7px;
  }
}
.largerTotalLength {
  font-size: 18px;
  font-weight: bolder;
  padding-top: 3px;
  padding-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// Private_MIB.vue?24a767ae